module.exports = __webpack_public_path__ + "static/home-bg-pattern-a5969fb929c9f0446922fd0a01fa579d.svg";